import { useMediaQuery } from 'react-responsive'

export const useFiltersPanel = ({ desktopMinWidth = 1024 } = {}) => {
	const isDesktop = useMediaQuery({ minWidth: desktopMinWidth })
	return { isDesktop }
}
